/**
 * Generated with @muse/import-icons
 * Do not edit directly
 */

import { createIcon } from '../lib/create-icon';

export const CheckmarkCircleIcon = createIcon(
  '0 0 20 20',
  <path
    fillRule="evenodd"
    d="M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16m5.264-10.854-6.203 7.33-3.768-3.769 1.414-1.414 2.232 2.231 4.798-5.67z"
    clipRule="evenodd"
  />,
);
